import React, { useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

// ---------------------------------------------------------------- Sales dashboard
export function SalesView() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/admin/sales").then(({ data }) => setD(data)).catch(() => {}); }, []);
  if (!d) return <div><div className="adm-h1">Sales</div><div className="adm-sub">Loading…</div></div>;
  return (
    <div data-testid="sales-view">
      <div className="adm-h1">Sales</div>
      <div className="adm-sub">Revenue from guide & bundle orders (test-mode purchases included).</div>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(160px,1fr))", gap: 12, margin: "12px 0" }}>
        {[["₹ Revenue", "₹" + (d.revenue.inr || 0).toLocaleString("en-IN")],
          ["$ Revenue", "$" + (d.revenue.usd || 0).toLocaleString("en-US")],
          ["Orders", d.order_count], ["Complete-Library members", d.complete_library_members]].map(([k, v]) => (
          <div key={k} className="card2" style={{ textAlign: "center" }}><div style={{ fontSize: 26, fontWeight: 800, color: "var(--navy)" }}>{v}</div><div style={{ fontSize: 12, color: "var(--grey)" }}>{k}</div></div>
        ))}
      </div>
      <div className="card2">
        <b style={{ color: "var(--navy)" }}>Top sellers</b>
        <table className="adm-table"><thead><tr><th>Item</th><th>Units</th><th>₹ rev</th><th>$ rev</th></tr></thead>
          <tbody>{d.top_items.map((t) => <tr key={t.slug}><td>{t.slug}</td><td>{t.units}</td><td>₹{(t.rev_inr || 0).toLocaleString("en-IN")}</td><td>${(t.rev_usd || 0).toLocaleString("en-US")}</td></tr>)}
          {d.top_items.length === 0 && <tr><td colSpan="4" style={{ color: "var(--grey)", padding: 16 }}>No sales yet.</td></tr>}</tbody></table>
      </div>
    </div>
  );
}

// ---------------------------------------------------------------- D4 Batch RFQ
export function RFQView() {
  const [rfqs, setRfqs] = useState([]);
  const [open, setOpen] = useState(null);
  const [cats, setCats] = useState([]);
  const [form, setForm] = useState({ title: "", product: "", category: "", specs: "", qty: "", target_price: "", destination: "", certifications: "", timeline: "", incoterm: "FOB" });
  const load = () => api.get("/rfqs").then(({ data }) => setRfqs(data.rfqs)).catch(() => {});
  useEffect(() => { load(); api.get("/suppliers/categories").then(({ data }) => setCats(data.categories)).catch(() => {}); }, []);
  const create = async () => {
    if (!form.product) return;
    const { data } = await api.post("/rfqs", form);
    setForm({ title: "", product: "", category: "", specs: "", qty: "", target_price: "", destination: "", certifications: "", timeline: "", incoterm: "FOB" });
    load(); setOpen(data.id);
  };
  if (open) return <RFQDetail rid={open} cats={cats} onBack={() => { setOpen(null); load(); }} />;
  return (
    <div data-testid="rfq-view">
      <div className="adm-h1">Batch RFQ</div>
      <div className="adm-sub">Create a requirement, pick suppliers, and send personalised bilingual RFQs. Nothing sends without your click.</div>
      <div className="card2">
        <b style={{ color: "var(--navy)" }}>New requirement</b>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 6, marginTop: 6 }}>
          <input className="adm-input" placeholder="Product *" value={form.product} onChange={(e) => setForm({ ...form, product: e.target.value })} data-testid="rfq-product" />
          <select className="adm-input" value={form.category} onChange={(e) => setForm({ ...form, category: e.target.value })}><option value="">Category</option>{cats.map((c) => <option key={c}>{c}</option>)}</select>
          <input className="adm-input" placeholder="Incoterm" value={form.incoterm} onChange={(e) => setForm({ ...form, incoterm: e.target.value })} />
          <input className="adm-input" placeholder="Quantity / MOQ" value={form.qty} onChange={(e) => setForm({ ...form, qty: e.target.value })} />
          <input className="adm-input" placeholder="Target price" value={form.target_price} onChange={(e) => setForm({ ...form, target_price: e.target.value })} />
          <input className="adm-input" placeholder="Destination" value={form.destination} onChange={(e) => setForm({ ...form, destination: e.target.value })} />
          <input className="adm-input" placeholder="Certifications" value={form.certifications} onChange={(e) => setForm({ ...form, certifications: e.target.value })} />
          <input className="adm-input" placeholder="Timeline" value={form.timeline} onChange={(e) => setForm({ ...form, timeline: e.target.value })} />
        </div>
        <textarea className="adm-input" placeholder="Specs" value={form.specs} onChange={(e) => setForm({ ...form, specs: e.target.value })} style={{ minHeight: 50 }} />
        <button className="btn btn-red" onClick={create} data-testid="rfq-create">Create RFQ</button>
      </div>
      <div className="card2" style={{ padding: 0 }}>
        <table className="adm-table"><thead><tr><th>Product</th><th>Category</th><th>Recipients</th><th>Created</th></tr></thead>
          <tbody>{rfqs.map((r) => <tr key={r.id} data-testid={`rfq-row-${r.id}`}><td><button style={{ background: "none", border: "none", color: "var(--navy)", fontWeight: 700, cursor: "pointer" }} onClick={() => setOpen(r.id)}>{r.product || r.title}</button></td><td>{r.category}</td><td>{r.recipient_count}</td><td style={{ fontSize: 12 }}>{(r.created_at || "").slice(0, 10)}</td></tr>)}
          {rfqs.length === 0 && <tr><td colSpan="4" style={{ color: "var(--grey)", padding: 16 }}>No RFQs yet.</td></tr>}</tbody></table>
      </div>
    </div>
  );
}

function RFQDetail({ rid, onBack }) {
  const [data, setData] = useState(null);
  const [sugs, setSugs] = useState([]);
  const [pick, setPick] = useState([]);
  const load = useCallback(() => api.get(`/rfqs/${rid}`).then(({ data }) => setData(data)).catch(() => {}), [rid]);
  useEffect(() => { load(); api.get(`/rfqs/${rid}/suggest`).then(({ data }) => setSugs(data.suppliers)).catch(() => {}); }, [rid, load]);
  const toggle = (id) => setPick((p) => p.includes(id) ? p.filter((x) => x !== id) : (p.length < 30 ? [...p, id] : p));
  const addRecipients = async () => { await api.post(`/rfqs/${rid}/recipients`, { supplier_ids: pick }); setPick([]); load(); };
  if (!data) return <div><button className="btn btn-line" onClick={onBack}>← Back</button><p>Loading…</p></div>;
  const r = data.rfq;
  return (
    <div data-testid="rfq-detail">
      <button className="btn btn-line" onClick={onBack} style={{ marginBottom: 8 }}>← Back</button>
      <div className="adm-h1">{r.product}</div>
      <div className="adm-sub">{r.category} · {r.qty} · {r.incoterm} · {r.destination}</div>

      <div className="card2">
        <b style={{ color: "var(--navy)" }}>Ranked suppliers</b> <span style={{ fontSize: 12, color: "var(--grey)" }}>(pick 1–30 · {pick.length} selected)</span>
        <button className="btn btn-red" style={{ float: "right", padding: "6px 12px" }} disabled={!pick.length} onClick={addRecipients} data-testid="rfq-add-recipients">Generate drafts for {pick.length}</button>
        <div style={{ maxHeight: 240, overflow: "auto", marginTop: 8 }}>
          {sugs.map((s) => (
            <label key={s.id} style={{ display: "flex", gap: 8, alignItems: "center", padding: "6px 0", borderTop: "1px dashed var(--line)", opacity: s.opt_out ? 0.4 : 1 }} data-testid={`sug-${s.id}`}>
              <input type="checkbox" checked={pick.includes(s.id)} disabled={s.opt_out} onChange={() => toggle(s.id)} />
              <b style={{ color: "var(--navy)" }}>{s.company_name}</b> <span style={{ fontSize: 12, color: "var(--grey)" }}>{s.company_name_cn} · {s.type} · {s.verified_status} · score {s.score}</span>
              {s.contacted_recently && <span style={{ fontSize: 11, color: "#B45309", background: "#FEF3C7", padding: "1px 6px", borderRadius: 6 }}>contacted &lt;14d</span>}
            </label>
          ))}
        </div>
      </div>

      <div className="card2">
        <b style={{ color: "var(--navy)" }}>Recipients & drafts ({data.messages.length})</b>
        {data.messages.map((m) => <RFQMessage key={m.id} m={m} onChange={load} />)}
      </div>
    </div>
  );
}

function RFQMessage({ m, onChange }) {
  const [en, setEn] = useState(m.draft_en);
  const [cn, setCn] = useState(m.draft_cn);
  const [q, setQ] = useState(m.quote || {});
  const [reply, setReply] = useState("");
  const saveDraft = async () => { await api.put(`/rfq-messages/${m.id}`, { draft_en: en, draft_cn: cn }); onChange(); };
  const send = async () => { try { await api.post(`/rfq-messages/${m.id}/send`); onChange(); } catch (e) { alert(e.response?.data?.detail || "Send failed"); } };
  const prefill = async () => { const { data } = await api.post(`/rfq-messages/${m.id}/quote-prefill`, { reply }); setQ(data.quote || {}); };
  const saveQuote = async () => { await api.put(`/rfq-messages/${m.id}`, { quote: q, status: "quoted" }); onChange(); };
  return (
    <div style={{ borderTop: "1px dashed var(--line)", padding: "10px 0" }} data-testid={`rfq-msg-${m.id}`}>
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <b>{m.supplier_name} <span style={{ fontSize: 12, color: "var(--grey)" }}>{m.email}</span></b>
        <span className={"pill " + (m.status === "sent" ? "Proposal" : "New")} style={{ fontSize: 11 }}>{m.status}</span>
      </div>
      <textarea className="adm-input" value={en} onChange={(e) => setEn(e.target.value)} style={{ minHeight: 80 }} data-testid={`draft-en-${m.id}`} />
      {m.lang === "bilingual" && <textarea className="adm-input" value={cn} onChange={(e) => setCn(e.target.value)} style={{ minHeight: 80 }} placeholder="中文" />}
      <div style={{ display: "flex", gap: 6 }}>
        <button className="btn btn-line" style={{ padding: "6px 12px" }} onClick={saveDraft}>Save draft</button>
        <button className="btn btn-red" style={{ padding: "6px 12px" }} onClick={send} data-testid={`send-${m.id}`} disabled={m.status === "sent"}>{m.status === "sent" ? "Sent ✓" : "Send now"}</button>
      </div>
      {m.status === "sent" && (
        <div style={{ marginTop: 8 }}>
          <textarea className="adm-input" placeholder="Paste supplier reply to auto-fill quote…" value={reply} onChange={(e) => setReply(e.target.value)} style={{ minHeight: 44 }} />
          <button className="btn btn-line" style={{ padding: "5px 10px" }} onClick={prefill}>Extract quote</button>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(4,1fr)", gap: 4, marginTop: 4 }}>
            {["unit_price", "currency", "moq", "lead_time", "incoterm", "port", "validity"].map((k) => (
              <input key={k} className="adm-input" placeholder={k} value={q[k] || ""} onChange={(e) => setQ({ ...q, [k]: e.target.value })} />
            ))}
          </div>
          <button className="btn btn-navy" style={{ padding: "5px 10px" }} onClick={saveQuote} data-testid={`save-quote-${m.id}`}>Save quote</button>
        </div>
      )}
    </div>
  );
}
